import React from "react";

const ACTIVE_PATH = "M9 18L15 12L9 6";
const DISABLED_PATH = "M15 18L9 12L15 6";

export default function ChevronIcon({ active = true, direction = "next", className = "svg-88 placed-nav-chevron", ...props }) {
  const path = active ? ACTIVE_PATH : DISABLED_PATH;
  const stroke = active ? "#4338CA" : "#94A3B8";
  const rotate =
    direction === "prev" ? (active ? "rotate(180deg)" : "none") : active ? "none" : "rotate(180deg)";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ transform: rotate }}
      aria-hidden="true"
      {...props}
    >
      <path d={path} stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
